import React from "react";
import { Star, ShieldCheck, HeartPulse, Award, BadgeCheck } from "lucide-react";

const TESTIMONIALS = [
  {
    quote:
      "They transformed our wedding weekend. Every parent guest could relax, and the kids had the time of their lives. Impeccable, warm, and utterly professional.",
    author: "Amelia R.",
    role: "Mother of two · Wedding client",
    testid: "testimonial-1",
  },
  {
    quote:
      "We travel constantly for work. Care Anywhere has become our family's silent co-pilot — vetted, calm, and consistently exceptional in every city.",
    author: "Daniel & Priya S.",
    role: "Family of three · Travel client",
    testid: "testimonial-2",
  },
  {
    quote:
      "Our leadership offsite ran flawlessly because parents could be present. The care team was safety-first and genuinely wonderful with our children.",
    author: "Marcus K.",
    role: "COO · Corporate client",
    testid: "testimonial-3",
  },
];

const BADGES = [
  { icon: HeartPulse, label: "CPR & First Aid Certified", testid: "badge-cpr" },
  { icon: ShieldCheck, label: "Background Verified", testid: "badge-background" },
  { icon: BadgeCheck, label: "TrustLine Registered", testid: "badge-trustline" },
  { icon: Award, label: "Fully Insured & Bonded", testid: "badge-insured" },
];

const Trust = () => {
  return (
    <section
      id="trust"
      data-testid="trust-section"
      className="relative py-24 lg:py-32 bg-muted/40"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="max-w-2xl">
          <div className="text-xs tracking-[0.25em] uppercase text-primary/80">
            Trust &amp; Credibility
          </div>
          <h2 className="mt-4 font-serif-display text-4xl sm:text-5xl leading-[1.1] tracking-tight text-foreground">
            Trusted by families who don't compromise.
          </h2>
        </div>

        {/* Testimonials */}
        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {TESTIMONIALS.map((t, i) => (
            <figure
              key={t.testid}
              data-testid={t.testid}
              className="relative flex flex-col justify-between p-8 rounded-2xl bg-background border border-border/70 fade-up"
              style={{ animationDelay: `${i * 100}ms` }}
            >
              <div className="flex items-center gap-1 text-accent">
                {Array.from({ length: 5 }).map((_, idx) => (
                  <Star key={idx} size={15} className="fill-current" />
                ))}
              </div>
              <blockquote className="mt-5 font-serif-display text-lg leading-snug text-foreground">
                &ldquo;{t.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-6 pt-5 border-t border-border/70">
                <div className="text-sm font-medium text-foreground">{t.author}</div>
                <div className="text-xs text-muted-foreground mt-0.5">{t.role}</div>
              </figcaption>
            </figure>
          ))}
        </div>

        {/* Badges */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-4">
          {BADGES.map(({ icon: Icon, label, testid }) => (
            <div
              key={testid}
              data-testid={testid}
              className="flex items-center gap-3 p-5 rounded-xl bg-background border border-border/70"
            >
              <div className="h-10 w-10 rounded-full bg-primary/10 flex items-center justify-center">
                <Icon size={18} className="text-primary" />
              </div>
              <div className="text-sm font-medium text-foreground">{label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Trust;
